import { Component } from "react";
import PropTypes from "prop-types";

const options = {
  weekday: "long",
};
var ordertype = "";
class StatusAccount extends Component {
  formatDate = (d) => {
    var date = new Date(d);
    var dd = date.getDate();
    var mm = date.getMonth() + 1;
    var yyyy = date.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    return (d = yyyy + "-" + mm + "-" + dd);
  };

  calculatetarife = (amount) => {
    var numerador = 25000;
    var denominador = 24159;
    var secondNum = 72500;
    var result = amount * (numerador / denominador) + secondNum / denominador;

    return result - amount;
  };

  /* Función para calcular el estado de cuenta por tienda */
  calculateAccountStatus = (arrayX, idshop, cat, documents, zona, nameshop) => {
    //console.log("calculateAccountStatus", arrayX);
    var zonee = "";
    if (zona != null) {
      zonee = zona;
    } else {
      zonee = "No tiene zona asignada";
    }

    var documenteslegals = JSON.parse(
      documents === undefined ? "[]" : documents
    );

    var totalshop = 0;
    var subtractionmcc = 0;
    var arraytoReturn = [];
    //*CALCULO MCC
    var mcc25 = 0.25;
    var mcc = 0;
    //*FIN MCC

    var i = 0;
    var newObj = {};
    //*IVAS
    var iva8 = 0;
    var iva1 = 0;
    //*comisión de niku
    var comisión = 0;
    for (var i in arrayX) {
      ordertype = arrayX[i].order_type;
      var percentageceded =
        arrayX[i].shop_id.percentage_traded.value !== null
          ? arrayX[i].shop_id.percentage_traded.value
          : 0;

      newObj = {
        creacion: this.formatDate(arrayX[i].createdAt),
        id: arrayX[i].id,
        Fecha: "",
        Hora: "",
        Formadepago: "",
        importsindiscount: 0,
        Importventa: 0,
        importpluscomcustomer: 0,
        tarifeservice: 0,
        Descuentocl: 0,
        MCC: 0,
        Subtotal: 0,
        ComisionNk: 0,
        Subsiniva: 0,
        IVA8: 0,
        ISR1: 0,
        Comsend: 0,
        TotalADepositarporOrden: 0,
        Domicializacion: 0,
        TipoOrden: arrayX[i].order_type,
        ComsendCustomer:
          arrayX[i].com_customer !== null ? arrayX[i].com_customer : 0,
        propine: arrayX[i].propina !== null ? arrayX[i].propina : 0,
        deliveryman: "",
        idzona: zonee,
        finalTotalbd: arrayX[i].final_total,
        arreproducts: "",
        quantity: 0,
        subtotalpro: 0,
      };
      //console.log("ORDERFORTOP", arrayX[i].delivery_man_id);
      /* Condición para mandar nombre de repartidor */
      if (arrayX[i].delivery_man_id !== null) {
        newObj.deliveryman =
          arrayX[i].delivery_man_id.name +
          " " +
          arrayX[i].delivery_man_id.last_name;
      } else {
        newObj.deliveryman = "No hay repartidor en esta orden";
      }

      //*resultado de comisión de envio de result
      var sendshop = arrayX[i].com_shop !== null ? arrayX[i].com_shop : 0;
      //* Resultado de metodo de pago
      var method_pay = arrayX[i].method_pay.toUpperCase();
      //*resultado del total
      var total = parseFloat(arrayX[i].total);
      //* resultado de descuento
      var discount =
        method_pay === "EFECTIVO"
          ? Math.ceil(parseFloat(arrayX[i].discount))
          : parseFloat(arrayX[i].discount);
      //* resultado de monero electronico por orden finalizada

      //*Modificacion de descuento ------> valor del cedido;
      mcc = parseFloat(
        (((arrayX[i].total * percentageceded) / 100) * mcc25).toFixed(2)
      );
      //* Resultado de la fecha por orden final
      const event = new Date(arrayX[i].createdAt);
      //* subtotal total-descuento
      var submonto = parseFloat((total - discount).toFixed(2));
      //*Submonto - monedero
      var subtotalmcc = parseFloat((submonto - mcc).toFixed(2));
      var importpluscomservicecustom =
        submonto +
        (arrayX[i].com_customer !== null ? arrayX[i].com_customer : 0);
      if (cat === "Restaurantes") {
        comisión = parseFloat((subtotalmcc * 0.08).toFixed(2));
      } else if (cat === "Gas") {
        comisión = parseFloat((subtotalmcc * 0.01).toFixed(2));
      } else if (nameshop.substr(0, 4) === "2 am") {
        /* arreproducts = arrayX[i].products.items.length > 0 ? arrayX[i].products.items : []; */
        comisión = subtotalmcc * 0.04 * 1.16;
      } else {
        comisión = parseFloat((subtotalmcc * 0.06).toFixed(2));
      }

      subtractionmcc = parseFloat(subtotalmcc.toFixed(2)); //* Asignacion de sub total sin IVA

      //!INICIO DE RECONOCMIENTO DE DATOS FISCALES
      if (documenteslegals !== null) {
        //*SOLO ENTRA SI YA ESTA EL ATRIBUTO EN ESA TIENDA
        if (
          documenteslegals.contrato_fisica !== "" &&
          documenteslegals.contrato_fisica !== undefined
        ) {
          //*YA TIENE CONTRATO FISICO
          if (method_pay === "TARJETA") {
            //?EN ORDENES ONLINE Y PRESENCIALES
            subtractionmcc = parseFloat((subtotalmcc / 1.16).toFixed(2));
            iva8 = parseFloat((subtractionmcc * 0.08).toFixed(2));
            iva1 = parseFloat((subtractionmcc * 0.01).toFixed(2));
          } else {
            //?EN ORDENES EN EFECTIVO
            subtractionmcc = parseFloat((subtotalmcc / 1.16).toFixed(2));
            iva8 = 0;
            iva1 = 0;
          }
        } else if (
          documenteslegals.contrato_moral !== "" &&
          documenteslegals.contrato_moral !== undefined
        ) {
          //*TIENE CONTRATO MORAL
          iva8 = 0;
          iva1 = 0;
        } else {
          //*LLega el JSON pero datos vacios
          //*aca hago el calculo tomandolas en cuenta como fisicas en los que hacen los updates en la bd
          //console.log("sin info json vacio", idshop);

          if (method_pay === "TARJETA") {
            subtractionmcc = parseFloat((subtotalmcc / 1.16).toFixed(2));
            //?EN ORDENES ONLINE Y PRESENCIALES ACA NO EXISTE CONTRATO FISICA
            iva8 = parseFloat((subtractionmcc * 0.08).toFixed(2));
            iva1 = parseFloat((subtractionmcc * 0.01).toFixed(2));
          } else {
            //?EN ORDENES ONLINE Y PRESENCIALES PERO EN EFECTIVO NO SE VA A CALCULAR EL IVA
            subtractionmcc = parseFloat((subtotalmcc / 1.16).toFixed(2));
            iva8 = 0;
            iva1 = 0;
          }
        }
      } else {
        //*No existe el json en la bd
        //*acá hago el calculo tomandolas en cuenta como fisicas en los que hacen los updates en la bd
        if (method_pay === "TARJETA") {
          subtractionmcc = parseFloat((subtotalmcc / 1.16).toFixed(2));
          //?EN ORDENES ONLINE Y PRESENCIALES ACA NO EXISTE CONTRATO FISICA
          iva8 = parseFloat((subtractionmcc * 0.08).toFixed(2));
          iva1 = parseFloat((subtractionmcc * 0.01).toFixed(2));
        } else {
          //?EN ORDENES ONLINE Y PRESENCIALES PERO EN EFECTIVO NO SE VA A CALCULAR EL IVA
          subtractionmcc = parseFloat((subtotalmcc / 1.16).toFixed(2));
          iva8 = 0;
          iva1 = 0;
        }
      }

      //!LA TIENDA LLEVA COMISIÓN DE ENVIO
      /* SE LE VA A */
      if (sendshop > 0) {
        //*SE LE VA A AGREGAR LA COMISIÓN DE ENVIO
        //* subtotal + mcc- comision de niku - iva8 - isr -envio;
        totalshop = subtotalmcc - (sendshop + comisión + iva8 + iva1);
      } else {
        totalshop =
          subtotalmcc - (comisión + iva8 + iva1 + mcc) /*  + iva8 + iva1 */;
      }

      //!ESTA CONDICION APLICA PARA SERVICIO, PRESENCIAL Y ONLINE PERO EN EFECTIVO
      if (method_pay.toUpperCase() === "EFECTIVO") {
        totalshop = mcc + comisión + sendshop;

        newObj.Domicializacion = parseFloat(totalshop.toFixed(2));
      } else {
        newObj.Domicializacion = 0;
      }

      // Asignacion de valores aL objeto
      newObj.id = arrayX[i].id;
      newObj.Fecha = event.toLocaleDateString(undefined, options);
      newObj.Hora = event.getHours() + ":" + event.getMinutes();
      newObj.Formadepago = method_pay !== undefined ? method_pay : "";
      newObj.Importventa = total;
      newObj.importsindiscount = submonto;
      newObj.Descuentocl = discount;
      newObj.MCC = mcc;
      newObj.Subtotal = subtotalmcc;
      newObj.ComisionNk = comisión;
      newObj.Subsiniva = subtractionmcc;
      newObj.IVA8 = iva8;
      newObj.ISR1 = iva1;
      newObj.Comsend = sendshop > 0 ? sendshop : 0;
      newObj.TotalADepositarporOrden =
        newObj.Domicializacion > 0 ? 0 : parseFloat(totalshop.toFixed(2));
      newObj.importpluscomcustomer = parseFloat(
        importpluscomservicecustom.toFixed(2)
      );
      newObj.tarifeservice = parseFloat(
        this.calculatetarife(newObj.importpluscomcustomer).toFixed(2)
      );
      arraytoReturn.push(newObj);
    }

    return arraytoReturn;
  };

  /* Función para crear cálculo de comisiones */
  getCalculate = (arre) => {
    //Recorremos el arre que recibe para devolver sus propiedades del arreglo
    var arreshops = arre;
    var res = [];
    arreshops.map((item) => {
      //Destructing array
      const { category_shop, id, orders, shop_name, url_documents, zone } =
        item;
      //Filtrando por item con ordenes finalizadas
      if (orders.items.length > 0) 
      {
        //*Arreglo de ordenes cálculadas
        var arreOrders =  this.calculateAccountStatus(
          orders.items,
          id,
          category_shop,
          url_documents,
          zone,
          shop_name
        );
        var amounPropine = 0, comSendShop = 0, comSendClient = 0, comisionNk =0;
        //*Se hace el recorrido de ordenes calculadas para sumer popinas
        for(var i in arreOrders){
          amounPropine += arreOrders[i].propine;
          comSendShop += arreOrders[i].Comsend;
          comSendClient += arreOrders[i].ComsendCustomer;
          comisionNk += arreOrders[i].ComisionNk;
        }
        var resObj = {
          id: id,
          shop_name: shop_name,
          amountPropine: parseFloat(amounPropine.toFixed(2)),
          comSendShops: comSendShop,
          comSendClients: comSendClient,
          comisionNks: (parseFloat(comisionNk.toFixed(2)) / 2),
          orders: arreOrders,
          orderslength: arreOrders.length,
          total: (parseFloat(comisionNk.toFixed(2)) / 2)  +amounPropine+ comSendShop + comSendClient,
        }
        res.push(resObj);
      }

    });
    return res;
  };
}

StatusAccount.propTypes = { children: PropTypes.func.isRequired };

export default StatusAccount;
